var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"w-100 bg-white sticky-top"},[_c('app-header')],1),_c('div',{staticClass:"app-wrapper"},[_c('router-view',{staticClass:"ex-wrapper"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }